import { Col, DatePicker, Input, Modal, Row, Select, Form, Upload, Button } from 'antd'
import dayjs from 'dayjs'
import React, { useContext, useEffect, useState } from 'react'
import { addResignation, getallDeveloperForTask, getSingleResignation } from '../../utils/API';
import { UploadChangeParam } from 'antd/es/upload';
import { UploadFile } from 'antd/lib';
import { RcFile } from 'antd/lib/upload';
import { DeleteOutlined, FileImageOutlined, FilePdfOutlined, FileUnknownOutlined, FileWordOutlined, UploadOutlined } from '@ant-design/icons';
import { AuthContext } from '../../Auth/AuthContext';

interface AddResignationModalProps {
    visible: boolean;
    onCancel: () => void;
    onCreate?: () => void;
    refreshData: () => void;
}

const AddResignationModal: React.FC<AddResignationModalProps> = ({
    visible,
    onCancel,
    onCreate,
    refreshData,
}) => {
    const { authData } = useContext(AuthContext);
    const isAdmins = authData.roleId?.roleId === 1;
    const [form] = Form.useForm();
    const [developer, setDeveloper] = useState<any>(null);
    const [users, setUsers] = useState<any[]>([]);
    const imageUrl = process.env.REACT_APP_Image_URL || "";
    const [Document, setDocument] = useState<File[]>([]);
    const [fileListDocument, setFileListDocument] = useState<UploadFile<File>[]>([]);

    const handleDeleteDocument = (doc: File, index: number) => {
        const newDocument = [...Document];
        newDocument.splice(index, 1);
        setDocument(newDocument);

        const newFileListDocument = [...fileListDocument];
        newFileListDocument.splice(index, 1);
        setFileListDocument(newFileListDocument);
    };

    const getFileIcon = (fileName: string) => {
        const ext = fileName.split(".").pop()?.toLowerCase();
        if (ext === "pdf") return <FilePdfOutlined className="text-2xl text-red-500 mb-1" />;
        if (ext === "doc" || ext === "docx") return <FileWordOutlined className="text-2xl text-blue-500 mb-1" />;
        if (ext === "jpg" || ext === "jpeg" || ext === "png") return <FileImageOutlined className="text-2xl text-green-500 mb-1" />;
        return <FileUnknownOutlined className="text-2xl text-gray-500 mb-1" />;
    };

    const getSingleResignationData = async (userId: string) => {
        try {
            const response = await getSingleResignation(userId);
            let resignationData = response?.data?.resignation;
            if (resignationData && !Array.isArray(resignationData)) {
                resignationData = [resignationData];
            }
            refreshData()
        } catch (error) {
            console.error("Error getting resignation:", error);
        }
    };

    const getAllUsersData = async () => {
        try {
            const response = await getallDeveloperForTask("", "");
            setUsers(response?.data || []);
        } catch (error) {
            console.error("Error getting all users:", error);
        }
    };

    const getAuthData = () => {
        const authDataString = localStorage.getItem("authData");
        const existingAuthData = authDataString ? JSON.parse(authDataString) : null;
        if (existingAuthData?.user) {
            setDeveloper(existingAuthData.user);
            if (existingAuthData.user?.roleId?.name === "Admin") {
                getAllUsersData();
            }
            refreshData();
        }
    };

    useEffect(() => {
        getAuthData()
    }, [])

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();

            // ✅ Build FormData for file upload
            const formData = new FormData();
            formData.append("id", developer?.roleId?.name === "Admin" ? values.developerId : developer._id);
            formData.append("name",
                developer?.roleId?.name === "Admin"
                    ? users.find(user => user._id === values.developerId)?.username
                    : developer.username
            );
            formData.append("date", values.date.format("YYYY-MM-DD"));
            formData.append("approvedDate", values.approvedDate ? values.approvedDate.format("DD-MM-YYYY") : "");
            formData.append("description", values.description);

            // ✅ Append attachments
            Document.forEach(file => {
                formData.append("attachments", file);
            });

            await addResignation(formData);

            onCancel();
            form.resetFields();
            setDocument([]);
            setFileListDocument([]);

            if (developer?.roleId?.name === "Admin") {
                refreshData();
            } else {
                await getSingleResignationData(developer._id);
            }
        } catch (error) {
            console.error("Error adding resignation:", error);
        }
    };

    return (
        <Modal
            open={visible}
            onCancel={onCancel}
            footer={null}
            width={600}
            centered={false}
            className="custom-modal"
            style={{
                bottom: 20,
                top: 20,
                maxHeight: 'calc(100vh - 30px)',
                margin: '0 auto',
                position: 'relative',
            }}
            bodyStyle={{
                overflowY: "auto",
                fontFamily: "inter, sans-serif",
            }}
            styles={{
                header: {
                    padding: "12px",
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f5ffff",
                },
                content: {
                    padding: 0,
                    overflow: "hidden",
                },
            }}
            title={
                <div
                    style={{
                        color: "#4b5563",
                        fontFamily: "inter, sans-serif",
                        fontSize: "20px",
                        fontWeight: 500,
                    }}
                >
                    Apply For Resignation
                </div>
            }
        >
            <Form
                onFinish={handleSubmit}
                initialValues={{
                    name: developer?.username || '',
                    userId: developer?.roleId?.name === "Admin" ? undefined : developer?._id,
                }}
                form={form}
                layout="horizontal"
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 19 }}
                colon={false}
                style={{ margin: 0 }}
            >
                <div className="elements">
                    {developer?.roleId?.name !== "Admin" ? (
                        <Form.Item
                            label={
                                <span
                                    style={{
                                        color: "#4b5563",
                                        fontFamily: "inter, sans-serif",
                                        fontSize: "14px",
                                        paddingLeft: "15px",
                                        fontWeight: 500,
                                    }}
                                >
                                    Full Name<span className="text-red-500">*</span>
                                </span>
                            }
                            required={false}
                            name="name"
                            className=''
                            rules={[{ required: true, message: 'Please enter your name' }]}
                        >
                            <Input disabled className='Allinput' placeholder="Enter your name" />
                        </Form.Item>
                    ) : (
                        <Form.Item
                            label={
                                <span
                                    style={{
                                        color: "#4b5563",
                                        fontFamily: "inter, sans-serif",
                                        fontSize: "14px",
                                        paddingLeft: "15px",
                                        fontWeight: 500,
                                    }}
                                >
                                    Developer<span className="text-red-500">*</span>
                                </span>
                            }
                            required={false}
                            name="developerId"
                            rules={[{ required: true, message: 'Please select the developer' }]}
                        >
                            <Select placeholder="Select Developer ">
                                {users.map(user => (
                                    <Select.Option key={user._id} value={user._id}>{user.username}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    )}

                    <Form.Item
                        label={
                            <span
                                style={{
                                    color: "#4b5563",
                                    fontFamily: "inter, sans-serif",
                                    fontSize: "14px",
                                    paddingLeft: "15px",
                                    fontWeight: 500,
                                }}
                            >
                                Applied Date<span className="text-red-500">*</span>
                            </span>
                        }
                        required={false}
                        name="date"
                        rules={[{ required: true, message: "Please select date" }]}
                    >
                        <DatePicker
                            className="Allinput"
                            format="DD-MM-YYYY"
                            style={{ width: "100%" }}
                            disabledDate={current => current && current.isAfter(dayjs().endOf("day"))}
                        />
                    </Form.Item>

                    {developer?.roleId?.name === "Admin" && (
                        <Form.Item label={
                            <span
                                style={{
                                    color: "#4b5563",
                                    fontFamily: "inter, sans-serif",
                                    fontSize: "14px",
                                    paddingLeft: "15px",
                                    fontWeight: 500,
                                }}
                            >
                                Approved Date
                            </span>
                        }
                            required={false}
                            name="approvedDate">
                            <DatePicker className="Allinput" format="DD-MM-YYYY" style={{ width: '100%' }} />
                        </Form.Item>
                    )}

                    <Form.Item
                        label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Description <span className="text-red-500">*</span>
                            </span>
                        }
                        name="description"
                        required={false}
                        rules={[{ required: true, message: 'Enter Resignation description' }]}
                    >
                        <Input.TextArea
                            placeholder="Enter Resignation description"
                            className="Allinputtextarea"
                        />
                    </Form.Item>
                    {isAdmins && <Col span={24}>
                        <Form.Item label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Attachments
                            </span>
                        } name="attachments">
                            <div className="flex items-center gap-4 flex-wrap">
                                <Upload
                                    listType="picture-card"
                                    showUploadList={false}
                                    multiple
                                    fileList={fileListDocument}
                                    onChange={(info: UploadChangeParam<UploadFile<RcFile>>) => {
                                        const rawFiles = info.fileList.map((f) => f.originFileObj).filter((f): f is RcFile => !!f);
                                        setDocument(rawFiles);
                                        setFileListDocument(info.fileList);
                                    }}
                                    beforeUpload={() => false}
                                >
                                    <Button icon={<UploadOutlined />}>Upload</Button>
                                </Upload>

                                {Document.map((doc, index) => {
                                    const fileName = (doc as File).name;
                                    const fileUrl = URL.createObjectURL(doc);

                                    return (
                                        <div key={index} className="w-38 h-32 border-2 border-gray-200 rounded-lg bg-white relative flex flex-col items-center justify-center p-4">
                                            {getFileIcon(fileName)}
                                            <span className="text-xs font-medium text-gray-700 truncate w-full text-center">
                                                {fileName}
                                            </span>
                                            <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="absolute inset-0" onClick={(e) => e.stopPropagation()} />
                                            <button
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    handleDeleteDocument(doc, index);
                                                }}
                                                className="absolute top-2 right-2 text-red-500 hover:text-red-700 bg-white rounded-full p-1"
                                            >
                                                <DeleteOutlined style={{ fontSize: "12px" }} />
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        </Form.Item>
                    </Col>
                    }

                </div>

                <Row justify="end">
                    <Col span={24} className="d-flex justify-content-end me-3">
                        <div className="button-wrapper">
                            <button onClick={onCancel} className="allcanclebutton" type="button">
                                Cancel
                            </button>
                            <button className="allsubmitebutton w-52" type="submit">
                                Submit
                            </button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </Modal>
    )
}

export default AddResignationModal
